//school project repository
export const schoolProjectItems = [
          {
            title: "Gen Alpha Brainrot Learning Management System",
            subheading: "SMU: CS203 Collborative Software Development",
            image: [],
            desc: [
              "A brainrot-themed Learning Management System built on microservices, where students create and consume lessons with AI-assisted content generation.",
              "Tracks student progress including lesson enrolment and detailed item-level completions.",
              "Evaluates quiz submissions automatically and updates course completion metrics.",
              "Leverages AI background workers to generate and moderate educational content dynamically.",
              "Project development simulated an agile software development life-cycle."
            ],
            skills: [
              "React",
              "TypeScript",
              "Vite",
              "AWS",
              "Java",
              "SpringBoot",
              "Python",
              "Keycloak",
              "Docker",
              "PostgreSQL",
              "RabbitMQ"
            ],
            repo: "https://github.com/Joseph-LohYeKai/CS203-Project",
            website: "https://csdskibiddi.com"
          },
          {
            title: "JMS: Just Meal Savers",
            subheading: "SMU: IS213 Enterprise Solution Development",
            image: [],
            desc: [
              "A microservices-based meal deals marketplace built on a distributed, event-driven architecture.",
              "Browse, purchase, and manage discounted meals from various sellers.",
              "Execute complex purchasing and refund workflows seamlessly using Temporal.",
              "Participate in the Clean Plate Challenge and earn loyalty points using OpenAI to verify before-and-after meal photos.",
              "Ensure robust system scalability and security with Kong API Gateway, RabbitMQ message brokering, and Keycloak authentication."
            ],
            skills: [
              "React.js",
              "Vite",
              "TypeScript",
              "Python",
              "FastAPI",
              "Docker",
              "PostgreSQL",
              "AWS",
              "RabbitMQ",
              "Temporal",
              "Kong",
              "Stripe",
              "Firebase"
            ],
            repo: "https://github.com/Nicholas1811/is213-backend",
            website: ""
          },
          {
          title: "Peddit: Pet Social Media Web Application",
          subheading: "SMU: IS216 Web Application Development II",
          image: [
            "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/smuProjects/peddit/Profile.png",
            "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/smuProjects/peddit/pet+health+dashboard+closed.png",
            "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/smuProjects/peddit/Pet+creation.jpg",
            "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/smuProjects/peddit/social+search.jpg",
            "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/smuProjects/peddit/social+post.jpg",
            "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/smuProjects/peddit/recipe+creation+nutrition+summary.jpg",
            "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/smuProjects/peddit/nearby+vet+and+pet+store+map+search+full.jpg"
          ],
          desc: [
              "Create pet profiles, track health, and analyze nutrition of pets.",
              "Build and share recipes and meals.",
              "Post socially and interact with the community.",
              "Find nearby pet shops and clinics with Google Maps.",
              "Get AI assistance via an integrated chatbot."
          ],
          skills: ["Vue.JS", "Vite", "Bootstrap", "Supabase", "Vercel"],
          repo: "https://github.com/oreoolis/Peddit",
          website: "https://peddit-coral.vercel.app/"
      },
      {
        title: "Face Recognition Attendance",
        subheading: "SMU: CS102 Programming Fundamentals II",
        image: [],
        desc: [
          "A backend application for managing student enrollment, session tracking, and automated attendance marking.",
          "Features multi-face, static, and live face detection capabilities.",
          "Automatically updates attendance statuses such as late or absent.",
          "Supports batch updates via CSV and report exports in PDF and CSV formats.",
          "Includes logging and automated email notifications for summarized professor reports and absent student alerts."
        ],
        skills: [
          "Java",
          "Spring Boot",
          "Maven",
          "OpenCV",
          "AWS S3",
          "Docker"
        ],
        repo: "https://github.com/Darren322/cs102-opencv",
        website: ""
      },
      {
          title: "APD Labs Events Management Portal",
          subheading: "Polytechnic Final Year Project",
          image: [
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/apdLabsPortal/proj7-1.png",
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/apdLabsPortal/proj7-2.png",
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/apdLabsPortal/proj7-3.png",
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/apdLabsPortal/proj7-4.png",
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/apdLabsPortal/proj7-5.png"
          ],
          desc: [
              "Allows users to create, edit and attend events created, based on their user permissions.",
              "Implements a payment API (Stripe) for administrator registration and event attendance."
          ],
          skills: ["Angular", "Node.JS", "Visual Studio C++ (.NET)", "Stripe"],
          repo: "https://github.com/oreoolis/APDLabsApplication"
      },
      {
          title: "Student Grade Predictor",
          subheading: "Machine Learning for Developers",
          image: [
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/gradePredictor/proj6-1.png",
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/gradePredictor/proj6-2.png"
          ],
          desc: [
              "A simple website that predicts the grade of the student based on environmental or social factors.",
              "Utilises Python libraries to compute imported data from Kaggle to output a predicted grade."
          ],
          skills: ["HTML", "CSS", "Python"],
          repo: "https://github.com/oreoolis/StudentGradePredictor"
      },
      {
          title: "Covid-19 Cases Dashboard",
          subheading: "Microservices",
          image: [
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/covidDashboard/proj5-1.png",
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/covidDashboard/proj5-2.png",
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/covidDashboard/proj5-3.png",
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/covidDashboard/proj5-4.png",
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/covidDashboard/proj5-5.png"
          ],
          desc: [
              "Allows users to create, update, and delete statistics of COVID-19 cases.",
              "Displays the number of Covid-19 cases using a Google Pie Chart API.",
              "Integrates an external Authentication login (Auth0) that allows administrators to edit data."
          ],
          skills: ["React.JS", "Node.JS", "Visual Studio C++ (.NET)", "Auth0"],
          repo: "https://github.com/oreoolis/CovidDashboard"
      },
      {
          title: "Recipe Creation and Compilation Mobile Application",
          subheading: "Mobile Application Development",
          image: [
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/confitRecipeApp/proj4-1.png",
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/confitRecipeApp/proj4-2.png",
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/confitRecipeApp/proj4-3.png",
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/confitRecipeApp/proj4-4.png"
          ],
          desc: [
              "Allows users to compile recipes of their own or save from online websites.",
              "Recipes and user data is stored and retrieved from Google Firebase",
              "Integrates with a Google login as a user login/registration alternative."
          ],
          skills: ["Android Studio", "Java", "Ionic Native", "Google Firebase"]
      },
      {
          title: "Learning Management System Portal",
          subheading: "Full Stack Web Development",
          image: [
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/quizPortal/proj3-1.png",
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/quizPortal/proj3-2.png",
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/quizPortal/proj3-3.png",
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/quizPortal/proj3-4.png"
          ],
          desc: [
              "Simulates a chatbot where portal administrators are able to add or remove questions based on students' inputs.",
              "Student users are able to attempt graded quizzes created by portal administrators and interact with the chatbot."
          ],
          skills: ["MongoDB", "Express", "Angular.JS", 'Node.JS']
      },
      {
          title: "Restaurant Review Website",
          subheading: "Coding and Development Project + Database Application Project",
          image: [
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/restaurantReview/proj2-1.png",
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/restaurantReview/proj2-2.png"
          ],
          desc: [
              "Users are able to read information about their favorite restaurants and leave reviews.",
              "Utilises a Google Maps API to visualize the location of the restaurant."
          ],
          skills: ["HTML", "CSS", "XAMPP", 'mySQL']
      },
      {
          title: "Music Player",
          subheading: "Computational Thinking + User Experience and Interface Design",
          image: [
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/snappyMusicPlayer/proj1-1.png",
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/snappyMusicPlayer/proj1-2.png",
              "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/images/polytechnicProjects/snappyMusicPlayer/proj1-3.png"
          ],
          desc: [
              "Serves basic music player functionalities such as looping, shuffling, fast forwarding through the use of arrays.",
              "Songs and album covers are loaded from a school-provided API."
          ],
          skills: ["Android Studio", "Java"]
      }
  ]